import { StepConfig } from '@/steps/types';

/**
 *  Available store mutation for the steps.
 */
export enum StepsMutation {
    /** Used to update the (current) step. */
    CURRENT = 'steps:current',
}

/**
 *  Holding the store's steps state.
 */
export interface StepsState {
    /**
     *  Holding the current step (config).
     */
    current: StepConfig | null;
}
